<!-- NAV BAR PLANES -->
<div *ngIf="post" id="planesSingle">
  <section class="resumen-plan">
    <div class="row h-100">
      <div class="col-12 col-lg-6 p-0 slider">
        <ng-container *ngIf="mobile; else sliderDesktop">
          <ngb-carousel
            [showNavigationArrows]="post.acf.slider.slide.length > 1"
            [showNavigationIndicators]="post.acf.slider.slide.length > 1"
            interval="7500"
            [keyboard]="true"
            [pauseOnHover]="true"
            [wrap]="true"
            [activeId]="'myCarousel'"
            *ngIf="post.acf.slider"
          >
            <ng-template
              ngbSlide
              *ngFor="let slide of post.acf.slider.slide; let i = index"
            >
              <div
                class="img d-block h-100 w-100"
                [ngStyle]="{
                  'background-image': 'url(' + slide.imagen_mobile + ')'
                }"
              ></div>
              <div
                class="img d-block h-100 w-100"
                [ngStyle]="{
                  'background-image': 'url(' + slide.imagen_mobile + ')'
                }"
              ></div>
              <div class="descripcion">
                <h2
                  *ngIf="slide.titulo"
                  [innerHTML]="slide.titulo"
                  class="slide-left"
                ></h2>
                <p
                  *ngIf="slide.bajada"
                  [innerHTML]="slide.bajada"
                  class="slide-left"
                ></p>
              </div>
            </ng-template>
          </ngb-carousel>
        </ng-container>
        <ng-template #sliderDesktop>
          <ngb-carousel
            [showNavigationArrows]="post.acf.slider.slide.length > 1"
            [showNavigationIndicators]="post.acf.slider.slide.length > 1"
            interval="7500"
            [keyboard]="true"
            [pauseOnHover]="true"
            [wrap]="true"
            [activeId]="'myCarousel'"
            *ngIf="post.acf.slider"
          >
            <ng-template
              ngbSlide
              *ngFor="let slide of post.acf.slider.slide; let i = index"
            >
              <div
                class="img d-block h-100 w-100"
                [ngStyle]="{ 'background-image': 'url(' + slide.imagen + ')' }"
              ></div>
              <div
                class="img d-block h-100 w-100"
                [ngStyle]="{ 'background-image': 'url(' + slide.imagen + ')' }"
              ></div>
              <div class="descripcion">
                <h2
                  *ngIf="slide.titulo"
                  [innerHTML]="slide.titulo"
                  class="slide-left"
                ></h2>
                <p
                  *ngIf="slide.bajada"
                  [innerHTML]="slide.bajada"
                  class="slide-left"
                ></p>
              </div>
            </ng-template>
          </ngb-carousel>
        </ng-template>
      </div>

      <div class="col-12 col-lg-6 my-auto">
        <div class="contentTxt">
          <h2 *ngIf="post.acf.resumen.top_titulo_derecha">
            {{ post.acf.resumen.top_titulo_derecha }}
          </h2>
          <p *ngIf="post.acf.resumen.titulo_derecha" class="subtitle">
            {{ post.acf.resumen.titulo_derecha }}
          </p>
          <div
            class="txt"
            [innerHTML]="transform(post.acf.resumen.bajada)"
          ></div>
          <p class="contentLink">
            <a
              *ngIf="!post.acf.resumen.deshabilitar_contratar_plan"
              (click)="contratar(post.slug)"
              href="javascript:void(0);"
              >contratÁ tu plan 100% online</a
            >
          </p>
        </div>
      </div>
    </div>
  </section>
  <!-- SLIDER SERVICIOS -->
  <section class="servicios-incluidos">
    <div class="row" *ngIf="!post.acf.deshabilitar_servicios">
      <div class="col-12">
        <div
          class="flex d-flex flex-column align-items-center justify-content-center titulos"
        >
          <h2>Servicios incluidos</h2>
          <p>
            Este plan incluye todos estos servicios médicos y asistenciales.<br />No
            tenés que sumarlos ni pagar extra, ya vienen con tu cobertura.
          </p>
        </div>
      </div>
    </div>
    <div class="carrousel-wrapper">
      <ngx-slick-carousel class="carousel" [config]="slideConfig">
        <div
          ngxSlickItem
          *ngFor="let servicios of post.acf.servicios"
          class="servicio-box"
        >
          <div class="servicio-content">
            <img [src]="servicios.icono" [alt]="servicios.titulo" />
            <h5>{{ servicios.titulo }}</h5>
            <p>{{ servicios.bajada }}</p>
          </div>
        </div>
      </ngx-slick-carousel>
    </div>
  </section>
  <!-- FINAL SLIDER SERVICIOS -->

  <!-- COMPARADOR -->
  <section class="comparador">
    <div
      class="mfade bd-example-modal-lg"
      id="modalPlanesSingle"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <ng-container *ngIf="mobile; else comparativaDesktop">
              <div class="comparativaMobile">
                <div class="row titulos">
                  <div class="col col-lg-5 my-auto">
                    <span>Servicios según su plan</span>
                  </div>
                  <div class="col my-auto"><span>Plan vittal Up</span></div>
                  <div class="col my-auto">
                    <span>Plan vittal Bienestar</span>
                  </div>
                  <div class="col my-auto">
                    <span>Plan vittal Integral</span>
                  </div>
                </div>
                <div class="row filas">
                  <div class="col-3 col-lg-5 my-auto">
                    <span>Emergencias y urgencias médicas 24hs</span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                </div>
                <div class="row filas">
                  <div class="col-3 col-lg-5 my-auto">
                    <span>Médico a domicilio 24hs</span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon no-incluido"></span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon con-copago"></span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                </div>
                <div class="row filas">
                  <div class="col-3 col-lg-5 my-auto">
                    <span>Médico de cabecera vittaldoc</span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                </div>
                <div class="row filas">
                  <div class="col-3 col-lg-5 my-auto">
                    <span>Consultas médicas online vittal iDoc</span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon con-copago"></span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon con-copago"></span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                </div>
                <div class="row filas">
                  <div class="col-3 col-lg-5 my-auto">
                    <span>Odontología de urgencia</span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon con-copago"></span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon con-copago"></span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon con-copago"></span>
                  </div>
                </div>
                <div class="row filas">
                  <div class="col-3 col-lg-5 my-auto">
                    <span>Asistencia al viajero nacional</span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                </div>
                <div class="row filas">
                  <div class="col-3 col-lg-5 my-auto">
                    <span>Asistencia internacional al viajero</span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon no-incluido"></span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                </div>
                <div class="row filas">
                  <div class="col-3 col-lg-5 my-auto">
                    <span>Apto físico escolar</span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon no-incluido"></span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                </div>
                <div class="row filas">
                  <div class="col-3 col-lg-5 my-auto">
                    <span>Apto físico Gym</span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon no-incluido"></span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                </div>
                <div class="row filas">
                  <div class="col-3 col-lg-5 my-auto">
                    <span>Vacunación antigripal (vacuna + aplicación)</span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon no-incluido"></span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon no-incluido"></span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                </div>
                <div class="row filas">
                  <div class="col-3 col-lg-5 my-auto">
                    <span>Cartilla médica online</span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                </div>
                <div class="row filas">
                  <div class="col-3 col-lg-5 my-auto">
                    <span>Descuentos en farmacias, ópticas y ortopedias</span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                </div>
                <div class="row filas">
                  <div class="col-3 col-lg-5 my-auto">
                    <span>Central de turnos</span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                </div>
                <div class="row resultados">
                  <div class="col-3 col-lg-5 my-auto">
                    <span>Precio final por persona desde:</span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="result">{{ planes[2]?.precio }}</span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="result">{{ planes[1]?.precio }}</span>
                  </div>
                  <div class="col-3 my-auto">
                    <span class="result">{{ planes[0]?.precio }}</span>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-template #comparativaDesktop>
              <div class="comparativaMobile">
                <div class="row titulos">
                  <div class="col col-lg-5 my-auto">
                    <span>Servicios según su plan</span>
                  </div>
                  <div class="col my-auto"><span>Plan vittal Up</span></div>
                  <div class="col my-auto">
                    <span>Plan vittal Bienestar</span>
                  </div>
                  <div class="col my-auto">
                    <span>Plan vittal Integral</span>
                  </div>
                </div>
                <div class="row filas">
                  <div class="col col-lg-5 my-auto">
                    <span>Emergencias y urgencias médicas 24hs</span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                </div>
                <div class="row filas">
                  <div class="col col-lg-5 my-auto">
                    <span>Médico a domicilio 24hs</span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon no-incluido"></span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon con-copago"></span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                </div>
                <div class="row filas">
                  <div class="col col-lg-5 my-auto">
                    <span>Médico de cabecera vittaldoc</span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                </div>
                <div class="row filas">
                  <div class="col col-lg-5 my-auto">
                    <span>Consultas médicas online vittal iDoc</span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon con-copago"></span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                </div>
                <div class="row filas">
                  <div class="col col-lg-5 my-auto">
                    <span>Odontología de urgencia</span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-copago"></span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-copago"></span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-copago"></span>
                  </div>
                </div>
                <div class="row filas">
                  <div class="col col-lg-5 my-auto">
                    <span>Asistencia al viajero nacional</span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                </div>
                <div class="row filas">
                  <div class="col col-lg-5 my-auto">
                    <span>Asistencia internacional al viajero</span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon no-incluido"></span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                </div>
                <div class="row filas">
                  <div class="col col-lg-5 my-auto">
                    <span>Apto físico escolar</span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon no-incluido"></span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                </div>
                <div class="row filas">
                  <div class="col col-lg-5 my-auto">
                    <span>Apto físico Gym</span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon no-incluido"></span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                </div>
                <div class="row filas">
                  <div class="col col-lg-5 my-auto">
                    <span>Vacunación antigripal (vacuna + aplicación)</span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon no-incluido"></span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon no-incluido"></span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                </div>
                <div class="row filas">
                  <div class="col col-lg-5 my-auto">
                    <span>Descuentos en farmacias, ópticas y ortopedias</span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                </div>
                <div class="row filas">
                  <div class="col col-lg-5 my-auto">
                    <span>Cartilla médica online</span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                </div>
                <div class="row filas">
                  <div class="col col-lg-5 my-auto">
                    <span>Central de turnos</span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                  <div class="col my-auto">
                    <span class="icon sin-cargo"></span>
                  </div>
                </div>
                <div class="row resultados">
                  <div class="col col-lg-5 my-auto">
                    <span>Precio final por persona desde:</span>
                  </div>
                  <div class="col my-auto">
                    <span class="result">${{ planes[2]?.precio }}</span>
                  </div>
                  <div class="col my-auto">
                    <span class="result">${{ planes[1]?.precio }}</span>
                  </div>
                  <div class="col my-auto">
                    <span class="result">${{ planes[0]?.precio }}</span>
                  </div>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
    <div
      class="referencias-iconos d-flex flex-row align-items-center justify-content-center"
    >
      <span class="icon sin-cargo d-inline-block mx-2"> &nbsp;Sin cargo</span>
      <span class="icon sin-copago d-inline-block mx-2"> &nbsp;Sin copago</span>
      <span class="icon con-copago d-inline-block mx-2"> &nbsp;Con copago</span>
      <span class="icon no-incluido d-inline-block mx-2">
        &nbsp;No incluido</span
      >
    </div>
    <div
      class="contrata d-flex flex-column align-items-center justify-content-center"
    >
      <h3 class="w-md-50 text-center">
        ¿Ya sabés cuál es el ideal para vos o tu familia? Contratalo fácil y
        rápido desde acá.
      </h3>
      <p class="contentLink">
        <a
          *ngIf="!post.acf.resumen?.deshabilitar_contratar_plan"
          (click)="contratar(post.slug)"
          href="javascript:void(0);"
          >Contratá tu plan 100% online</a
        >
      </p>
    </div>
  </section>
  <!-- FINAL COMPARADOR -->

  <!-- FAQ'S -->
  <app-faq-toggles-home></app-faq-toggles-home>
  <!-- FIN FAQ'S -->

  <!-- VOLVER A PLANES -->
  <section class="ver-planes">
    <div
      class="flex d-flex flex-column align-items-center justify-content-center"
    >
      <h2>¿Este plan no es lo que estás buscando?</h2>
      <p>
        Conocé las otras opciones y encontrá el plan que mejor se adapta a vos o
        tu familia.
      </p>
      <button class="btn mt-3">
        <a href="/planes">VOLVER A LOS 3 PLANES</a>
      </button>
    </div>
  </section>
  <!-- FIN VOLVER A PLANES -->

  <!-- BOTON LEGALES -->
  <div class="row">
    <div class="container">
      <div
        class="col-12 contentItem aclaraciones flex d-flex flex-column align-items-center justify-content-center mb-4"
      >
        <div class="">
          <p *ngIf="post.acf.espicificaciones">
            {{ post.acf.espicificaciones }}
          </p>
          <a
            *ngIf="post.acf.legales.texto"
            data-toggle="modal"
            data-target="#modalLegales"
            class="legales"
            >{{ post.acf.legales.label }}</a
          >
        </div>
      </div>
    </div>
  </div>
  <!-- FIN BOTON LEGALES -->
  <!-- Modal LEGALES -->
  <div
    class="modal fade bd-example-modal-lg"
    id="modalLegales"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header" style="height: 23px">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div
          class="modal-body"
          [innerHTML]="transform(post.acf.legales.texto)"
          style="height: 500px; overflow-y: scroll"
        ></div>
      </div>
    </div>
  </div>
</div>
